// extracted by mini-css-extract-plugin
module.exports = {"cont":"BizCompanyDataViewCatchphrase_cont__1kwAn"};